import { IntroPrompt } from "@core/GUI/Dialogs/IntroPrompt";
import { Language, Messages } from "@core/GUI/Language";
import { Assets } from "@core/GUI/Utils/Assets";
import { Constants } from "@core/Utils/Constants";
import { setTextFontScaledToBox } from "@core/Utils/HelperFunction";

export class RouletteIntroPrompt extends IntroPrompt {
    private chips: Array<Phaser.GameObjects.Image>;
    private fields: Array<Phaser.GameObjects.Image>;
    private chipOnField: Phaser.GameObjects.Image;
    private howToPlayText: Phaser.GameObjects.Text;
    private myNum: number;
    private numColumns: number;
    private totalNums: number;

    constructor(public scene: Phaser.Scene, protected onClickCallback: Function) {
        super(scene, onClickCallback);
    }

    override resize(width: number, height: number, portraitMode: boolean = false): void {
        super.resize(width, height, portraitMode);
    }

    override drawIntro(): void {
        this.chips = new Array<Phaser.GameObjects.Image>();
        for (let c = 1; c < 6; c++) {
            let chip = new Phaser.GameObjects.Image(this.scene, 0, 0, Assets.chipAtlas, "chip" + (6 - c).toString() + "_D.png");
            chip.setOrigin(0, 0.5);
            this.chips.unshift(chip);
            this.add(chip);
        }

        let myNum = 9;
        this.numColumns = 5;
        this.totalNums = 15;
        this.fields = new Array<Phaser.GameObjects.Image>();
        for (let i = 0; i < this.numColumns; i++) {
            for (let j = this.totalNums / this.numColumns; j > 0; j--) {
                let field = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + myNum + ".png");
                field.setOrigin(1, 0);
                field.alpha = 1 - (Math.abs((i + 1) - (this.numColumns + 1) / 2) / this.numColumns) * 1.9;
                this.fields.push(field);
                this.add(field);
                myNum++;
            }
        }

        this.chipOnField = new Phaser.GameObjects.Image(this.scene, 0, 0, Assets.chipAtlas, "chip2_N.png");
        this.chipOnField.setOrigin(0.5, 0.5);
        this.chipOnField.visible = false;
        this.add(this.chipOnField);

        this.helpHand = new Phaser.GameObjects.Sprite(this.scene, 0, 0, Constants.ANIMATIONS.HELPHAND, "tap_0.png");
        this.helpHand.setOrigin(1, 1);
        this.add(this.helpHand);

        this.helpHand.anims.create({
            key: "pointerClick",
            frames: this.helpHand.anims.generateFrameNames(Constants.ANIMATIONS.HELPHAND, {
                prefix: 'tap_',
                end: 7,
                suffix: '.png'
            }),
            frameRate: 30,
            yoyo: true,
            repeat: 0
        });
        this.helpHand.addToUpdateList();

        this.howToPlayText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.INTRO_HOW_TO_PLAY), Constants.PANEL.BET_FONT);
        this.howToPlayText.setOrigin(0.5, 0);
        this.howToPlayText.setAlign("center");
        this.add(this.howToPlayText);

        this.descriptionText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.INTRO_HOW_TO_PLAY_DESCRIPTION), Constants.PANEL.BET_FONT);
        this.descriptionText.setOrigin(0, 0);
        this.descriptionText.setAlign("left");
        this.add(this.descriptionText);

        this.continueText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.CLICK_TO_CONTINUE), Constants.PANEL.BET_FONT);
        this.continueText.setOrigin(0.5, 0.5);
        this.continueText.setAlign("center");
        this.continueText.setShadow(0, 0, "black", 5, false, true);
        this.add(this.continueText);
    }

    override refreshIntro(width: number, height: number, portraitMode: boolean = false): void {
        this.chips.forEach((chip, index) => {
            chip.displayHeight = Math.min(height * 0.1, width * 0.1);
            chip.displayWidth = chip.displayHeight;
            chip.setPosition(width - width / 3 + (chip.displayWidth * 0.7 * index), height / 4);
        });

        let index = 0;
        for (let i = 0; i < this.numColumns; i++) {
            for (let j = this.totalNums / this.numColumns; j > 0; j--) {
                this.fields[index].displayWidth = Math.min(height * 0.125, width * 0.1);
                this.fields[index].displayHeight = this.fields[index].displayWidth * (this.fields[index].height / this.fields[index].width);
                this.fields[index].setPosition(this.fields[index].displayWidth * (1 + i) + ((width / 2) - 5.5 * this.fields[index].displayWidth), (height / 3) + this.fields[index].displayHeight * (j - 1));
                index++;
            }
        }

        this.chipOnField.setPosition(this.fields[7].x - this.fields[7].displayWidth / 2, this.fields[7].y + this.fields[7].displayHeight / 2);
        this.chipOnField.setDisplaySize(this.fields[0].displayHeight * 0.7, this.fields[0].displayHeight * 0.7);


        this.helpHand.displayWidth = height * 0.1;
        this.helpHand.displayHeight = this.helpHand.displayWidth * (this.helpHand.height / this.helpHand.width);
        this.helpHand.visible = true;
        this.helpHand.setPosition(0, 0);

        if (this.helpHandAnimationFirstClick) {
            this.helpHandAnimationFirstClick.stop();
            this.helpHandAnimationFirstClick = null;
        }

        this.helpHandAnimationFirstClick = this.scene.tweens.add({
            targets: this.helpHand,
            x: { from: 0, to: this.chips[1].x + this.chips[1].displayWidth / 2 + this.helpHand.displayWidth / 1.5 },
            y: { from: 0, to: this.chips[1].y + this.helpHand.displayHeight },
            ease: 'Linear',
            duration: 650,
            onStart: () => {
                this.helpHandAnimationSecondClick.restart();
                this.chipOnField.visible = false;
            },
            onComplete: () => {
                this.chipOnField.visible = false;
                this.helpHand.play("pointerClick");
                this.helpHand.once('animationcomplete', () => {
                    this.chips[1].setFrame("chip2_N.png");
                    if (this.helpHandAnimationSecondClick)
                        this.helpHandAnimationSecondClick.play();
                }, this);
            },
            repeat: 0,
            paused: true
        });


        if (this.helpHandAnimationSecondClick) {
            this.helpHandAnimationSecondClick.stop();
            this.helpHandAnimationSecondClick = null;
        }
        this.helpHandAnimationSecondClick = this.scene.tweens.add({
            targets: this.helpHand,
            x: { from: this.chips[1].x + this.helpHand.displayWidth / 2, to: this.fields[7].x - (this.fields[7].displayWidth / 2) + this.helpHand.displayWidth / 1.5 },
            y: { from: this.chips[1].y + this.helpHand.displayHeight, to: this.fields[7].y + (this.fields[7].displayHeight / 2) + this.helpHand.displayHeight },
            ease: 'Linear',
            duration: 650,
            onStart: () => {
                this.chipOnField.visible = false;
                this.helpHandAnimationFirstClick.restart();
            },
            onComplete: () => {
                this.helpHand.play("pointerClick");
                this.chipOnField.visible = true;
                this.helpHand.once('animationcomplete', () => {
                    this.chips[1].setFrame("chip2_D.png");
                    this.chipOnField.visible = false;
                    if (this.helpHandAnimationFirstClick)
                        this.helpHandAnimationFirstClick.play();
                }, this);
            },
            repeat: 0,
            paused: false
        });

        this.helpHandAnimationFirstClick.play();

        this.howToPlayText.setPosition(width / 2, height * 0.1);
        let descFontSize = setTextFontScaledToBox(this.howToPlayText, width / 6, height * 0.1);
        this.howToPlayText.setFontSize(descFontSize);

        this.descriptionText.setPosition(width / 2, this.fields[2].y + this.fields[2].displayHeight / 2);
        this.descriptionText.setFontSize(descFontSize * 0.75);
        this.descriptionText.setWordWrapWidth(width * 0.45);
        this.descriptionText.runWordWrap(this.continueText.text);

        this.continueText.setPosition(width / 2, height * 0.9);
        setTextFontScaledToBox(this.continueText, Math.min(width * 0.4, height), height * 0.2);
    }

}